import styled from 'styled-components';
import TripsHeaderSVG from '../../assets/header/ic-mytrips.svg';

const TripsHeaderIcon = styled(TripsHeaderSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '1.9rem'};
  height: ${props => props.height || '2.5rem'};
  fill: ${props => props.color};
  margin: ${props => props.margin};
`;

export default TripsHeaderIcon;
